import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CurrencyProvider } from "@/lib/CurrencyContext";
import { TripAdvisor } from "@/components/TripAdvisor";
import { WhatsAppWidget } from "@/components/WhatsAppWidget";
import { PromoBanner } from "@/components/PromoBanner";
import HomePage from "@/pages/HomePage";
import ToursPage from "@/pages/ToursPage";
import TourDetailPage from "@/pages/TourDetailPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import BookingConfirmation from "@/pages/BookingConfirmation";
import MyBookingsPage from "@/pages/MyBookingsPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import LegalPage from "@/pages/LegalPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import { ProtectedRoute } from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/tours" element={<ToursPage />} />
      <Route path="/tours/:tourId" element={<TourDetailPage />} />
      <Route path="/booking-confirmation" element={<BookingConfirmation />} />
      <Route path="/my-bookings" element={<MyBookingsPage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/terms" element={<LegalPage page="terms" />} />
      <Route path="/privacy" element={<LegalPage page="privacy" />} />
      <Route path="/cancellation" element={<LegalPage page="cancellation" />} />
      <Route path="/contact" element={<LegalPage page="contact" />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CurrencyProvider>
        <Toaster position="top-right" richColors />
        <PromoBanner />
        <AppRouter />
        <TripAdvisor />
        <WhatsAppWidget />
      </CurrencyProvider>
    </BrowserRouter>
  );
}

export default App;
